import React, { Fragment, useEffect } from "react";
import axios from "axios";
import { useState } from "react";
import { QueryMethod } from "../Middleware/QueryMethod";
import { API_URL } from "../ConstVariable.js";
import { SetError } from "../redux-store/actions";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import moment from "moment";
import OperatorGuideLines from "../Components/operatorNotes/OperatorGuideLines";
var jmespath = require("jmespath");
const HelpNotesContainer = styled.div`
  width: 100%;

  ${"" /* border:1px solid lightgrey; */}
  ${"" /* height:8vh; */}
 ${"" /* min-height:2vh; */}
 ${"" /* padding:5px; */}
 ${"" /* overflow-y:auto; */}
 ${"" /* background:#F8EC88;  */}
`;
const Wrapper = styled.div`
  width: 100%;
  //   border: 1px solid lightgrey;
  ${"" /* height: 5vh; */}
  padding: 2px;
  overflow-y: auto;
  ${"" /* background: #f8ec88; */}
`;

const HelpNote = styled.ul`
  margin-bottom: -2px;
  padding-left: 20px;
  background: #f8ec88;
`;

const HelpNoteContainerName = styled.span`
  margin-bottom: 2px;
  font-weight: 600;
`;
const HelpNotesContaierWithError = styled.div`
  display: flex;
`;
const ErrorText = styled.p`
  background: #f7882b;
  padding: 3px;
`;
const LoadingText = styled.p`
  font-size: 14px;
  background: #f8ec88;

  ${"" /* paddingTop:-2px;
  paddingBottom:-2px; */
    }
  ${"" /* padding:3px 0px 3px 5px; */}
`;

const NoGuidelineText = styled.p`
  ${"" /* background:#FBEF3C; */}
  padding:5px;
  background: #f8ec88;
`;

let helpNotesDetails = {
    error_code: 0,
    error_description: "",
    helpnotes: [],
    rules: "",
};

const OperatorHelpNotes = ({
    center_id,
    modality,
    bodypart,
    bodypart_group,
    protocol,
    purpose_of_study,
    laterality,
    operatorNotesShouldFetch: shouldOperatorNotesFetch,
    operatorNotesFetchHandler,
    pregnancyWeeks,
    selectDateTime,
    conversationID,
    modalityGeneric,
    bodypartGeneric,
    protocolGeneric,
    purposeOfStudyGeneric,
    lateralityGeneric,
    bodypartGroupGeneric,
    speciality,
    order_description,
}) => {


    const [helpNotes, setHelpNotes] = useState({ ...helpNotesDetails });
    const [isRequestProcessing, setIsRequestProcessing] = useState(false);
    const [requestTimerId, setRequestTimerId] = useState(null);

    // useEffect(() => {
    //     return () => {
    //         setCancelToken(null);
    //     };
    // }, []);

    useEffect(() => {

        if (center_id && modality && modality.length > 1 && shouldOperatorNotesFetch) {
            setHelpNotes((prevState) => { return { ...prevState, ...helpNotesDetails } });

            clearTimeout(requestTimerId);
            let token = localStorage.getItem("MyToken");


            let requestData = {
                center_id,
                modality,
                bodypart,
                bodypart_group,
                protocol,
                purpose_of_study,
                laterality,
                modality_generic: modalityGeneric,
                bodypart_generic: bodypartGeneric,
                protocol_generic: protocolGeneric,
                purpose_of_study_generic: purposeOfStudyGeneric,
                laterality_generic: lateralityGeneric,
                bodypart_group_generic: bodypartGroupGeneric,
                speciality: speciality,
                procedure_description: order_description,
                appointment_datetime: moment(selectDateTime).format("yyyy-MM-DD HH:mm:ss") === "Invalid date" ? "" : moment(selectDateTime).format("yyyy-MM-DD HH:mm:ss"),
                conversation_id: conversationID
            };

            if (pregnancyWeeks) {
                requestData["weeks_since_pregnant"] = pregnancyWeeks;
            }
            console.log("requestData", requestData)
            setIsRequestProcessing(true);
            let timerId = setTimeout(() => {
                let URL = `${API_URL}/oi/api/operator-guidelines`;

                let responsePromise = QueryMethod(
                    URL,
                    setIsRequestProcessing,
                    requestData,
                    "POST"
                );
                responsePromise
                    .then((response) => {
                        if (!response.data.error_code) {
                            setHelpNotes((prevState) => {
                                return {
                                    ...prevState,
                                    ...response.data,
                                };
                            });
                        } else {
                            setHelpNotes((prevState) => {
                                return {
                                    ...prevState,
                                    ...response.data,
                                };
                            });
                        }
                        setIsRequestProcessing(false);
                        if (operatorNotesFetchHandler)
                            operatorNotesFetchHandler(false);
                    })
                    .catch((error) => {
                        setHelpNotes((prevState) => {
                            return {
                                ...prevState,
                                error_code: 102,
                                error_description:
                                    " Failed to get the operator's helping notes",
                                helpnotes: [],
                                rules: "",
                            };
                        });
                        if (operatorNotesFetchHandler)
                            operatorNotesFetchHandler(false);

                        setIsRequestProcessing(false);
                    });

                clearTimeout(requestTimerId);
            }, 1500);

            setRequestTimerId(timerId);
        }
        if (modality?.length === 0) {
            setHelpNotes((prevState) => {
                return { ...prevState, ...helpNotesDetails };
            });
            setIsRequestProcessing(false);
        }
    }, [
        shouldOperatorNotesFetch,
        center_id,
        modality,
        bodypart,
        bodypart_group,
        protocol,
        purpose_of_study,
        laterality,
        pregnancyWeeks,
        selectDateTime
        
    ]);

    const HelpNotes = () => {
        return <Fragment></Fragment>;
    };

    return (
        <Fragment>
            <HelpNotesContainer>
                {isRequestProcessing ? (
                    <LoadingText> Loading the operator helping notes...</LoadingText>
                ) : (helpNotes.error_code === 101 || helpNotes.error_code !== 0) ?
                    <NoGuidelineText> {helpNotes.error_description}</NoGuidelineText> : ""
                }


                {helpNotes?.rules &&
                    <Fragment>
                        <OperatorGuideLines helpNotes={helpNotes} />
                    </Fragment>
                }
            </HelpNotesContainer>
        </Fragment>
    );
};

export default OperatorHelpNotes;